import PAGRating from '../Types'

type Props = {
  app: PAGRating.App
  subApp?: PAGRating.SubApp
  module?: PAGRating.Module
}

const ApplicationInformation = (data: Props) => {
  const getPropertyValue = (
    propModule: keyof PAGRating.Module,
    propSubApp: keyof PAGRating.SubApp,
    propApp: keyof PAGRating.App
  ) => {
    let returnedValue: any
    if (data.module?.[propModule]) {
      returnedValue = data.module?.[propModule]
    } else if (data.subApp?.[propSubApp]) {
      returnedValue = data.subApp?.[propSubApp]
    } else {
      returnedValue = data.app[propApp]
    }
    return returnedValue
  }

  let parents = {}
  let type = ''
  if (data.module?.configId) {
    type = 'module'
    parents = {
      idApp: data.app.app,
      idSubApp: data.subApp?.subAppId
    }
  } else if (data.subApp?.configId) {
    type = 'subApp'
    parents = {
      idApp: data.app.app
    }
  } else {
    type = 'app'
  }
  return {
    icto: data.app.icto,
    title: getPropertyValue('moduleDescription', 'subAppDescription', 'appDescription'),
    appId: getPropertyValue('appId', 'appId', 'appId'),
    department: getPropertyValue('department', 'department', 'department'),
    members: getPropertyValue('members', 'members', 'members'),
    businessResponsible: getPropertyValue('businessResponsible', 'businessResponsible', 'businessResponsible'),
    configId: getPropertyValue('configId', 'configId', 'configId'),
    id: getPropertyValue('moduleId', 'subAppId', 'app'),
    apiKey: (data.app as any).apiKey || '',
    type: type,
    parents: parents
  }
}

export default ApplicationInformation
